var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoostReturns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "#CFA809",
    fillOpacity: 0.35
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6784 19.9115L22.2475 28.3424L20.6892 26.7841L19.2705 25.3654L19.2589 25.3538L18.6542 24.7375C18.3169 24.4119 18.1309 23.97 18.1309 23.4932C18.1309 23.2373 18.189 22.9815 18.2937 22.7606C18.3751 22.5629 18.503 22.3884 18.6542 22.2373L19.6426 21.2488L21.573 19.3184L23.1196 17.7718L25.9687 14.9227C27.4921 16.9345 29.0387 18.5742 30.6784 19.9115Z",
    fill: "#E5B910",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.8635 19.3421C27.8053 19.784 27.4332 20.098 27.0029 20.098C26.9681 20.098 26.9215 20.0864 26.875 20.0864L21.5723 19.3189L23.1189 17.7722L27.1309 18.3537C27.6076 18.4234 27.9333 18.8653 27.8635 19.3421Z",
    fill: "#E5B910"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.0959 23.4119C26.0145 23.8305 25.654 24.1212 25.247 24.1212C25.1889 24.1212 25.1307 24.1096 25.0726 24.098L18.293 22.7607C18.3744 22.563 18.5023 22.3885 18.6535 22.2374L19.6419 21.2489L25.4098 22.3885C25.8866 22.4816 26.1889 22.9351 26.0959 23.4119Z",
    fill: "#E5B910"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.6891 26.7843C20.6542 26.8657 20.6077 26.9471 20.5496 27.0169C20.1077 27.6332 19.1541 28.3426 17.1307 28.1682C14.4328 27.9588 13.8048 28.9124 13.4327 29.4822C13.2699 29.7497 12.9908 29.8892 12.7001 29.8892C12.5373 29.8892 12.3745 29.8427 12.2349 29.7497C11.8279 29.4822 11.7116 28.9473 11.9675 28.5403C12.6884 27.4239 13.9444 26.168 17.2818 26.4238C18.2005 26.5169 18.875 26.3541 19.1425 26.0052C19.3053 25.7842 19.2936 25.4935 19.2704 25.3656L20.6891 26.7843Z",
    fill: "#E5B910"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8663 24.0365C14.3849 24.0365 13.9941 23.6458 13.9941 23.1644C13.9941 22.6829 14.3849 22.2864 14.8663 22.2864C15.3477 22.2864 15.7385 22.6713 15.7385 23.1527V23.1644C15.7385 23.6458 15.3477 24.0365 14.8663 24.0365Z",
    fill: "#E5B910"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6794 13.2832L34.1561 20.2954C34.1328 20.714 33.9002 21.0629 33.5398 21.2257C33.3886 21.3071 33.2141 21.342 33.0281 21.342C32.7723 21.342 32.5048 21.2606 32.2722 21.1094C32.2141 21.0629 32.1443 21.028 32.0861 20.9699L19.3176 33.7384C19.1432 33.9128 18.9222 33.9942 18.7013 33.9942C18.4803 33.9942 18.2594 33.9128 18.085 33.7384C17.7477 33.4011 17.7477 32.8429 18.085 32.5057L30.6791 19.9117C29.0394 18.5744 27.4927 16.9347 25.9694 14.9229C25.8531 14.7717 25.7484 14.6205 25.6321 14.4694C25.3414 14.0391 25.2833 13.5623 25.481 13.1786C25.6438 12.8181 26.0043 12.5971 26.4229 12.5622L33.4351 12.0389H33.5281C33.8305 12.0389 34.1328 12.1552 34.3421 12.3762C34.5864 12.6204 34.7026 12.946 34.6794 13.2832Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoostReturns);
export default __webpack_public_path__ + "static/media/boost-returns.a71c2398389e9f32a542dcc2758fbe5b.svg";
export { ForwardRef as ReactComponent };